const sizeOptions = [
    { value: 'small', label: { en: 'Small', es: 'Pequeño' } },
    { value: 'medium', label: { en: 'Medium', es: 'Mediano' } },
    { value: 'large', label: { en: 'Large', es: 'Grande' } },
];

export default sizeOptions;